export const iconRegistry = {
    menuCadastros: require('@/assets/icons/menuCadastros.svg'),
    menuColetas: require('@/assets/icons/menuColetas.png'),
    menuCollapse: require('@/assets/icons/menuCollapse.svg'),
    menuDoc1: require('@/assets/icons/menuDoc1.svg'),
    menuDoc2: require('@/assets/icons/menuDoc2.svg'),
    menuDocumentos: require('@/assets/icons/menuDocumentos.png'),
    menuDrive: require('@/assets/icons/drive.svg'),
    menuEditUser: require('@/assets/icons/menuEditUser.png'),
    menuEstabelecimentos: require('@/assets/icons/menuEstabelecimentos.png'),
    menuExpand: require('@/assets/icons/menuExpand.svg'),
    menuFolder: require('@/assets/icons/menuFolder.svg'),
    menuHelp: require('@/assets/icons/menuHelp.svg'),
    menuHistory: require('@/assets/icons/menuHistory.png'),
    menuIndustry: require('@/assets/icons/menuIndustry.svg'),
    menuLogout: require('@/assets/icons/menuLogout.svg'),
    menuManager: require('@/assets/icons/menuManager.svg'),
    menuMap: require('@/assets/icons/menuMap.svg'),
    menuOffice: require('@/assets/icons/menuOffice.svg'),
    menuOpcoes: require('@/assets/icons/menuOpcoes.svg'),
    menuPrinter: require('@/assets/icons/menuPrinter.png'),
    menuProcessos: require('@/assets/icons/menuProcessos.svg'),
    menuRAC: require('@/assets/icons/menuRAC.png'),
    menuSettings: require('@/assets/icons/menuSettings.svg'),
    menuSims: require('@/assets/icons/menuSims.png'),
    menuTable: require('@/assets/icons/menuTable.svg'),
    menuVistorias: require('@/assets/icons/menuVistorias.svg'),
    module: require('@/assets/icons/module.svg'),
    office1: require('@/assets/icons/office1.svg'),
    office2: require('@/assets/icons/office2.svg'),
    office3: require('@/assets/icons/office3.svg'),
    office4: require('@/assets/icons/office4.svg'),
    office5: require('@/assets/icons/office5.svg'),
    office6: require('@/assets/icons/office6.svg'),
    workflow1: require('@/assets/icons/workflow1.svg'),
    workflow2: require('@/assets/icons/workflow2.svg'),
    workflow3: require('@/assets/icons/workflow3.svg'),
    workflow4: require('@/assets/icons/workflow4.svg'),
    workflow5: require('@/assets/icons/workflow5.svg'),
    default: require('@/assets/icons/menuFolder.svg'),
};